import { createApi } from '@reduxjs/toolkit/query/react'

import baseQuery from './baseQuery'

export const profileAPI = createApi({
  reducerPath: 'profileAPI',
  baseQuery: baseQuery(),
  endpoints: builder => ({
    getProfile: builder.query({
      query: () => ({
        url: '/profile/',
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetProfileQuery } = profileAPI
